<template>
  <div>
    <div class="bg-dark" style="padding-bottom: 1.5rem; padding-top: 8rem">
      <div class="container">
        <header>
          <div class="row pb-5">
            <div class="col-md-7">
              <h1 class="header-title">Hörbuch Angebote</h1>
              <h2 class="fw-normal fs-3">Was wir dir anbieten, klingt gut.</h2>
            </div>
          </div>
        </header>

        <main>
          <!-- Selbständig -->
          <div class="row row-cols-1 row-cols-md-3 mb-3 text-center">
            <div class="col pb-4">
              <div class="card mb-4 rounded-3 shadow-sm h-100">
                <div class="card-header py-3">
                  <h4 class="my-0 fw-normal">Kostenrechner</h4>
                </div>
                <div class="card-body d-flex flex-column">
                  <div class="form-floating mb-3">
                    <input
                      v-model="numberOfPages"
                      class="form-control"
                      id="floatingInput"
                      placeholder="name@example.com"
                    />
                    <label for="floatingInput">Seitenanzahl</label>
                  </div>

                  <div class="row py-3">
                    <div class="col-8">
                      <div class="text-start ps-3">Aufnahmetage im Studio</div>
                    </div>
                    <div class="col">
                      <div class="text-end pe-3 fw-bold">{{ studioDays }}</div>
                    </div>
                  </div>

                  <div class="row pt-2">
                    <div class="col-8 h-100 d-flex align-items-center">
                      <div class="text-start ps-3">Hörspiel</div>
                    </div>
                    <div class="col">
                      <select
                        v-model="proSpeaker"
                        class="form-select"
                        aria-label="Default select example"
                      >
                        <option value="2">Ja</option>
                        <option selected value="1">Nein</option>
                      </select>
                    </div>
                  </div>

                  <div id="calculation" class="text-end mt-4 pt-2">
                    <span class="pe-3">Kostenvoranschlag:</span
                    ><span class="fw-bolder fs-4">{{ costs }} €</span>
                  </div>

                  <div class="text-end pt-4 info-text">
                    * Der Kostenrechner beinhaltet die Kostenpunkte
                    (Studiokosten,Post Produktion, Mastering sowie
                    Qualitätskontrolle)
                  </div>

                  <a
                    id="kostenrechner-hoerbuch"
                    class="mt-auto w-100 btn btn-lg btn-outline-primary standard-btn"
                    href="https://calendly.com/voiceart-productions/erstgespraech-hoerbuch"
                    target="_blank"
                  >
                    Anfragen
                  </a>
                </div>
              </div>
            </div>
            <div class="col pb-4">
              <div class="card mb-4 rounded-3 shadow-sm h-100">
                <div class="card-header py-3">
                  <h4 class="my-0 fw-normal">Self-Publisher</h4>
                </div>
                <div class="card-body d-flex flex-column">
                  <div
                    class="text-start px-3"
                    v-for="(publish, index) in publisher"
                    :key="publish.title"
                  >
                    <div class="d-flex py-1">
                      <div>
                        <svg
                          viewBox="0 0 16 16"
                          width="26"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <use href="../assets/svg/check.svg#check" />
                        </svg>
                      </div>
                      <div class="ps-2 text-start">{{ publish.title }}</div>
                      <div
                        class="ps-2 pointer"
                        data-bs-toggle="modal"
                        :data-bs-target="'#exampleModal' + index"
                      >
                        <svg
                          viewBox="0 0 16 16"
                          width="16"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <use
                            fill="white"
                            href="../assets/svg/info-circle.svg#info"
                          />
                        </svg>
                      </div>

                      <!-- Modal -->
                      <div
                        class="modal fade"
                        :id="'exampleModal' + index"
                        tabindex="-1"
                        aria-labelledby="exampleModalLabel"
                        aria-hidden="true"
                      >
                        <div class="modal-dialog modal-dialog-centered">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h1
                                class="modal-title fs-5"
                                id="exampleModalLabel"
                              >
                                {{ publish.title }}
                              </h1>
                              <button
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                              ></button>
                            </div>
                            <div class="modal-body">
                              {{ publish.description }}
                            </div>
                            <div class="modal-footer">
                              <button
                                type="button"
                                class="btn btn-primary"
                                data-bs-dismiss="modal"
                              >
                                Schließen
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <a
                    id="self-publisher-hoerbuch"
                    href="https://calendly.com/voiceart-productions/erstgespraech-hoerbuch"
                    target="_blank"
                    class="mt-auto w-100 btn btn-lg btn-primary"
                  >
                    Anfragen
                  </a>
                </div>
              </div>
            </div>
            <div class="col pb-4">
              <div class="card mb-4 rounded-3 shadow-sm border-primary h-100">
                <div class="card-header py-3 text-bg-primary border-primary">
                  <h4 class="my-0 fw-normal text-white">Verlage</h4>
                </div>
                <div class="card-body d-flex flex-column">
                  <div
                    class="text-start px-3"
                    v-for="(verlag, index) in verlage"
                    :key="verlag.title"
                  >
                    <div class="d-flex py-1">
                      <div>
                        <svg
                          viewBox="0 0 16 16"
                          width="26"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <use href="../assets/svg/check.svg#check" />
                        </svg>
                      </div>
                      <div class="ps-2 text-start">{{ verlag.title }}</div>
                      <div
                        class="ps-2 pointer"
                        data-bs-toggle="modal"
                        :data-bs-target="'#exampleModalVerlag' + index"
                      >
                        <svg
                          viewBox="0 0 16 16"
                          width="16"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <use
                            fill="white"
                            href="../assets/svg/info-circle.svg#info"
                          />
                        </svg>
                      </div>

                      <!-- Modal -->
                      <div
                        class="modal fade"
                        :id="'exampleModalVerlag' + index"
                        tabindex="-1"
                        aria-labelledby="exampleModalLabel"
                        aria-hidden="true"
                      >
                        <div class="modal-dialog modal-dialog-centered">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h1
                                class="modal-title fs-5"
                                id="exampleModalLabel"
                              >
                                {{ verlag.title }}
                              </h1>
                              <button
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                              ></button>
                            </div>
                            <div class="modal-body">
                              {{ verlag.description }}
                            </div>
                            <div class="modal-footer">
                              <button
                                type="button"
                                class="btn btn-primary"
                                data-bs-dismiss="modal"
                              >
                                Schließen
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <a
                    id="verlage-hoerbuch"
                    href="https://calendly.com/voiceart-productions/erstgespraech-hoerbuch"
                    class="mt-auto w-100 btn btn-lg btn-primary"
                    target="_blank"
                  >
                    Anfragen
                  </a>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useViewStore } from "../stores/ViewStore";

const viewStore = useViewStore();
const self = ref();
const company = ref();
const numberOfPages = ref(50);
const studioDays = ref();
const proSpeaker = ref(1);

const costs = computed(() => {
  studioDays.value = Math.ceil(numberOfPages.value / 100);

  let pageCosts =
    950 +
    650 * (studioDays.value - 1) +
    ((numberOfPages.value * 10) / 60) * 80 +
    ((numberOfPages.value * 2) / 60) * 50;

  if (proSpeaker.value == 1) {
    return Math.round(pageCosts * 0.7);
  }
  return Math.round(pageCosts);
});

const checkCustomer = () => {
  if (self.value.checked) {
    viewStore.toggleSelfActive(true);
  } else {
    viewStore.toggleSelfActive(false);
  }
};

const publisher = ref([
  {
    title: "Erstgespräch",
    description:
      "Im ersten Schritt führen wir ein Kennlerngespäch durch. Wir erklären alle wichtigen Abläufe einer Hörbuchproduktion, besprechen den zeitlichen Rahmen, die Kosten, Distribution und beantworten alle Fragen, die auf dem Herzen liegen!",
  },
  {
    title: "Aufnahme im Tonstudio",
    description:
      "In unserem High End  Tonstudio schaffen wir eine angenehme wohlfühl Atmosphäre in bester Aufnahmequalität.",
  },
  {
    title: "Post Produktion",
    description:
      "Nach der Aufnahme wird das Hörbuch sauber geschnitten. Schmatzer, Satzanfänge, kleinste Geräusche oder Versprecher entfernt und schlussendlich in eine Kapitelstrukur gebracht.",
  },
  {
    title: "Mastering",
    description:
      "Nach der Aufnahme wird das Hörbuch sauber geschnitten. Schmatzer, Satzanfänge, kleinste Geräusche oder Versprecher entfernt und schlussendlich in eine Kapitelstrukur gebracht.",
  },
  {
    title: "Qualitätskontrolle",
    description:
      "Qualität ist gut, Kontrolle ist besser. Dein Hörbuch wird ein letztes mal von Anfang bis Ende  durchgehört.",
  },
  {
    title: "Distribution & Vermarktung",
    description:
      " Durch unser breites Netzwerk an digitaler Distributoren & Partner, beraten wir dich gerne bei der Veröffentlichung  deines Hörbuches. ",
  },
]);

const verlage = ref([
  {
    title: "Erstgespräch",
    description:
      "Im ersten Schritt führen wir ein Kennlerngespäch durch. Wir erklären alle wichtigen Abläufe einer Hörbuchproduktion, besprechen den zeitlichen Rahmen, die Kosten, Distribution und beantworten alle Fragen, die auf dem Herzen liegen!",
  },
  {
    title: "Aufnahme im Tonstudio",
    description:
      "In unserem High End  Tonstudio schaffen wir eine angenehme wohlfühl Atmosphäre in bester Aufnahmequalität.",
  },
  {
    title: "Post Produktion",
    description:
      "Nach der Aufnahme wird das Hörbuch sauber geschnitten. Schmatzer, Satzanfänge, kleinste Geräusche oder Versprecher entfernt und schlussendlich in eine Kapitelstrukur gebracht.",
  },
  {
    title: "Mastering",
    description:
      "Nach der Aufnahme wird das Hörbuch sauber geschnitten. Schmatzer, Satzanfänge, kleinste Geräusche oder Versprecher entfernt und schlussendlich in eine Kapitelstrukur gebracht.",
  },
  {
    title: "Qualitätskontrolle",
    description:
      "Qualität ist gut, Kontrolle ist besser. Dein Hörbuch wird ein letztes mal von Anfang bis Ende  durchgehört.",
  },
]);
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Bangers&display=swap");

#calculation {
  border-top: 1px solid black;
}

.info-text {
  font-size: 0.75rem;
  color: #8a8a8a;
}

.bd-placeholder-img {
  font-size: 1.125rem;
  text-anchor: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}

@media (min-width: 768px) {
  .bd-placeholder-img-lg {
    font-size: 3.5rem;
  }
}

.b-example-divider {
  height: 3rem;
  background-color: rgba(0, 0, 0, 0.1);
  border: solid rgba(0, 0, 0, 0.15);
  border-width: 1px 0;
  box-shadow:
    inset 0 0.5em 1.5em rgba(0, 0, 0, 0.1),
    inset 0 0.125em 0.5em rgba(0, 0, 0, 0.15);
}

.b-example-vr {
  flex-shrink: 0;
  width: 1.5rem;
  height: 100vh;
}

.bi {
  vertical-align: -0.125em;
  fill: currentColor;
}

.textStart {
  padding-top: 2rem;
  text-align: center !important;
}

.nav-scroller {
  position: relative;
  z-index: 2;
  height: 2.75rem;
  overflow-y: hidden;
}

.nav-scroller .nav {
  display: flex;
  flex-wrap: nowrap;
  padding-bottom: 1rem;
  margin-top: -1px;
  overflow-x: auto;
  text-align: center;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
}

.header-title {
  color: #fc4667;
  font-weight: 700;
  font-size: 3.5rem;
}

h2 {
  color: rgb(185, 185, 185);
}

p {
  color: #747474;
  font-size: 1.1rem;
}

.standard-btn:hover {
  color: white;
}
</style>
